import styled from 'styled-components';
import { ClearLink } from '#/shared/components/Styled/ClearLink';
import ExternalLink from '#/shared/components/GeneratedIcons/trimet/ExternalLink';

export const CardBody = styled.div`
  display: flex;
  padding: 20px 20px 10px;
  user-select: none;
  background-color: ${props => props.theme.cardBg};
  border: 1px solid ${props => props.theme.cardBorder};
  border-radius: 8px;
  margin-top: 10px;
  align-items: initial;
  font-size: 1em;
`;

export const Title = styled.h1`
  font-size: 22px;
  color: ${props => props.theme.contentText};
`;

export const Description = styled.p`
  color: ${props => props.theme.contentText};
  margin-bottom: 8px;
`;

export const IconColumn = styled.div`
  flex: 0 0 75px;
  display: flex;
  justify-content: center;
  align-items: left;
  margin-right: 20px;
`;

export const DescriptionColumn = styled.div`
  flex: 1 1 auto;
  justify-content: left;
  font-size: 16px;
  margin-left: 5px;
`;

export const LinkSpan = styled.span`
  font-size: 14px;
  padding: 8px 8px 8px 0;
  line-height: 1;
`;

export const LinkRow = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-content: center;
  font-size: 1em;
`;

export const CardLink = styled(ClearLink)`
  color: ${props => props.theme.cardExternalLink};
  padding: 8px;
  @media (any-hover: hover) {
    &:hover {
      background-color: ${props => props.theme.cardExternalLinkBgHover};
    }
  }
`;

export const ExternalLinkIcon = styled(ExternalLink).attrs(props => ({
  fill: props.theme.cardExternalLink,
  width: '14px',
  height: '14px',
}))`
  margin-bottom: -1px;
`;
